import React from "react";
import img1 from "../../images/background/img20.jpg";
import img2 from "../../images/activities/education/img (93).jpg";

const Mission = () => {
  return (
    <div className="mission" data-aos="fade-up">
      <div className="mission-container">
        {/* Vision Section */}
        <div className="mission-section" data-aos="fade-up" data-aos-delay="100">
          <div className="mission-image">
            <img 
              src={img1}
              alt="Empowered Afghan youth looking towards the future"
              loading="lazy"
            />
          </div>
          <div className="mission-content">
            <h1>
              <span className="mission-icon" role="img" aria-label="vision">👁️</span>
              Our Vision
            </h1>
            <p>
              An empowered generation of Afghan youth building a stronger future through education.
            </p>
          </div>
        </div>

        {/* Mission Section */}
        <div className="mission-section reverse" data-aos="fade-up" data-aos-delay="200">
          <div className="mission-content">
            <h1>
              <span className="mission-icon" role="img" aria-label="mission">🎯</span>
              Our Mission
            </h1>
            <p>
              Action Not Word supports underserved schools in Afghanistan by providing financial and 
              educational assistance, empowering youth through quality education to build stronger 
              communities and a brighter future.
            </p>
          </div>
          <div className="mission-image">
            <img 
              src={img2}
              alt="Students learning together in a classroom"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mission;
